import { render } from "./ApprovedReferral.vue?vue&type=template&id=b7362b42"
import script from "./ApprovedReferral.vue?vue&type=script&lang=js"
export * from "./ApprovedReferral.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__